<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import axios from 'axios'
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'

  const { mapState } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    data () {
      return {
        user: store.get('user')
      }
    },
    computed: mapState([
      'activity'
    ]),
    created () {
      this.channel.bind('connection.opened', ({ connection, participant }) => {
        if (participant.userId === this.user.id) {
          this.unmuteOnBackend(connection.id)
        }
      })
    },
    methods: {
      unmuteOnBackend (connectionId) {
        axios.post(`${jiminnyHost()}/api/v1/activity/${this.activity.id}/connection/${connectionId}/unmute`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// connection-opened.vue?c9705f46